import { render } from "./AboutView.vue?vue&type=template&id=6ba862c4&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=6ba862c4&lang=css"
import "./AboutView.vue?vue&type=style&index=1&id=6ba862c4&scoped=true&lang=scss"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba862c4"]])

export default __exports__